import React, { useEffect, useState, useRef } from "react";

import { useParams } from 'react-router-dom';

import axios from "axios";
import { abaddress } from "../component/Abiaddress";
import { ethers } from "ethers";
import moment from "moment";
import Authuser from "../api/Authuser";






export default function Withdrawal() {

  const { userid } = useParams();
  const { http } = Authuser();
  const [walletdetails, setWalletdetails] = useState([]);
  const [balance, setBalance] = useState(0);
  const [totalbalance, setTotalbalance] = useState(null);
  const [transferaddress, setAddress] = useState();
  const [otp, setOtp] = useState();
  const [mobileotp, setMobileotp] = useState();
  const [otpbox, setOtpbox] = useState(0);
  const [successmsg, setSuccessmsg] = useState(null);
  const [errormsg, setErrormsg] = useState(null);
  const [loading, setloading] = useState('off');
  const [amount, setAmount] = useState(null);
  const [userwithdrawal, setUserwithdrawal] = useState([]);
  const [receiveamount, setRecevieamount] = useState(null);
  const [transactioncharge, setTransactioncharge] = useState(null);
  const [finalamount, setFinalamount] = useState(null);
  const [erroraddress, setErroraddress] = useState();
  const [erroramount, setErroramount] = useState();
  const [errormassege, setErrormassege] = useState();
  const [errordatemsg, setErrorDate] = useState();
  const [addresscheck, setAddresscheck] = useState();
  const [day, setDay] = useState();
  const [withdrawallock, setWithdrawallock] = useState();
  const [totalwithdrawal, setWithdrawal] = useState();

  const [attempts, setAttempts] = useState(0);
  const [locked, setLocked] = useState(false);

  useEffect(() => {
    localStorage.setItem('sanxloginid', userid);
    getwalletdetails();
    getuserwithdrawal();
    gettotalwithdrawal();
    getaddresscheck();
    dayfind();
    getwithdrawallock();
  }, []);

  const gettotalwithdrawal = () => {
    http.get('/total-withdrawal/' + userid).then(res => {
      setWithdrawal(res.data);
    });
  }

  const getaddresscheck = () => {
    http.get('/address-check/' + userid).then(res => {
      setAddresscheck(res.data);
    });
  }

  const getwithdrawallock = () => {
    http.get('/withdrawal-transfer-lock/' + userid).then(res => {
      setWithdrawallock(res.data);
    });
  }


  const getwalletdetails = () => {
    http.get('/get-wallet-address/' + userid).then(res => {
      setWalletdetails(res.data);
      const walletAddress = res.data.address;
      const totalbalance = res.data.totalbalance;
      const tbalance = totalbalance.toFixed(2)
      setTotalbalance(tbalance);
      const providerUrl = 'https://bsc-dataseed.binance.org/';
      getUSDTBalance(walletAddress, providerUrl)
        .then(balance => {
          if (balance !== null) {
            setBalance(balance);

          } else {
            //console.log('Failed to retrieve USDT balance');
          }
        });
      // setTotalbalance(balance+res.data.totalbalance);
    });
  };
  // balance show
  async function getUSDTBalance(walletAddress, providerUrl) {
    const usdtContractAddress = '0x55d398326f99059ff775485246999027b3197955';
    const usdtContractAbi = abaddress;
    try {
      // Create provider with the BSC provider URL
      const provider = new ethers.providers.JsonRpcProvider(providerUrl);

      // Instantiate the USDT contract
      const usdtContract = new ethers.Contract(usdtContractAddress, usdtContractAbi, provider);

      // Get the balance of the wallet address
      const balance = await usdtContract.balanceOf(walletAddress);
      const decimalAdjustedBalance = balance.div(ethers.BigNumber.from(10).pow(12));
      const formattedBalance = ethers.utils.formatUnits(decimalAdjustedBalance, 6);
      return formattedBalance;
    } catch (error) {
      //console.error('Error getting USDT balance:', error);
      return null;
    }
  }



  const checkaddress = (e) => {

    var address = e.target.value;
    setAddress(address);
    // http.get('/check-address/'+address).then(res=>{
    //     if(address=res.data.address){
    //       setAddress(address);
    //       setErrmsg('Address valid');
    //       setShowButton('on');
    //     }else{
    //       setErrmsg('Address not valid!');
    //       setShowButton('off');

    //     }

    // });
  }

  const nextbuttonclick = () => {
    setloading('on');

    http.post('/withdrawal-otp-send', { userid: userid, address: addresscheck, amount: amount }).then(res => {

      if (res.data.status == 422) {
        setErroraddress(res.data.error.address);
        setErroramount(res.data.error.amount);
        setOtpbox(0);
      } else if (res.data.status == 300) {
        setErrormassege(res.data.balanceerror);
        setOtpbox(0);
      } else if (res.data.status == 400) {
        setErrormassege(res.data.validerror);
        setOtpbox(0);
      } else if (res.data.status == 200) {
        setErroraddress('');
        setErroramount('');
        setOtpbox(1);
      } else {
        setOtpbox(0);
      }
      setloading('off');
    });

  }

  const submitform = (e) => {

    http.post('/withdrawal-otp-check', { userid: userid, otp: otp, mobileotp: mobileotp }).then(res => {
      if (res.data.status == 200) {
        setErrormsg(null);
        setloading('on');
        http.post('/withdrawal-amount', { userid: userid, amount: amount, address: addresscheck, transactioncharge: transactioncharge, receiveamount: finalamount }).then(res => {
          setSuccessmsg('Successful');
          window.location.reload();
        });
        // sendtoken function call
      } else {
        const newAttempts = attempts + 1;
        setAttempts(newAttempts);
        if (newAttempts > 2) {
          setLocked(true);
          setErrormsg("Too many wrong attempts. Try again later.");
        } else {
          setErrormsg("Incorrect OTP. Try again.");
        }
      }
    });

  }

  // Transaction call function

  //end transaction 



  const getuserwithdrawal = () => {
    http.get('/userwithdrawal/' + userid).then(res => {
      setUserwithdrawal(res.data);

    });
  }


  const withdrawalamount = (e) => {
    var withdrawalprice = e.target.value;
    if (withdrawalprice > 3 && withdrawalprice <= 5000) {
      var withdrawalprice = (withdrawalprice * 10)/100;
      if (withdrawalprice > 100) {
        var charge = "5%";
        var new_amount = (5 / 100) * withdrawalprice;
        setAmount(withdrawalprice);
        var finalamount = withdrawalprice - new_amount;
      } else {
        var charge = 3;
        var finalamount = withdrawalprice - 3;
        setAmount(withdrawalprice);
      }
      setRecevieamount(withdrawalprice);
      setFinalamount(finalamount);
      setTransactioncharge(charge);
    } else {
      setRecevieamount(0);
      setTransactioncharge(0);
      setFinalamount(0);
      setAmount(0);
    }
  }


  const dayfind = () => {
    const d = new Date();
    let day = d.getDay();
    setDay(day);
  }



  return (
    <div>

      <div className="main-wrapper">
        <div id="header" className="section header-section header-section-2 header-section-5 transparent-header">
          <div className="container">
            <div className="header-wrap">
              <div className="header-logo">
                <a className="logo-white" href="https://sanxmultitrades.com/dashboard"><img src="/assets/img/logo.png" alt="" /></a>
                <a className="logo-black" href="https://sanxmultitrades.com/dashboard"><img src="/assets/img/logo.png" alt="" /></a>
              </div>
              <div className="header-menu d-none d-lg-block">
                <ul className="main-menu">
                  <li>
                    <a href="https://sanxmultitrades.com/dashboard"><i className="fas fa-home"></i>Dashboard</a>
                  </li>
                  <li className="dropdown">
                    <a href="https://sanxmultitrades.com/profile/user-details"><i className="fas fa-user"></i>Profile</a>
                    <ul className="sub-menu">
                      <li><a href="https://sanxmultitrades.com/profile/user-details">User Details</a></li>
                      <li><a href="https://sanxmultitrades.com/profile/update-wallet">Wallet Address</a></li>
                      <li><a href="https://sanxmultitrades.com/profile/change-password"> Change Password</a></li>
                      <li><a href="https://sanxmultitrades.com/profile/refferal-link"> Refferal Link</a></li>
                    </ul>
                  </li>
                  <li>
                    <a href="#"><i className="fas fa-shopping-cart"></i>Subscription</a>
                    <ul className="sub-menu">
                      {/* <li><a href={`/botfee/${userid}`}> BOT Fee</a></li>
<li><a href={`/package/${userid}`}> Package</a></li> */}
                      <li><a href="https://sanxmultitrades.com/subscription/bot-fee">BOT Fee</a></li>
                      <li><a href="https://sanxmultitrades.com/subscription/package">Package</a></li>
                    </ul>
                  </li>
                  <li>
                    <a href="#"><i className="fas fa-dollar-sign"></i>Income</a>
                    <ul className="sub-menu">
                      <li><a href="https://sanxmultitrades.com/income/roi">ROI</a></li>
                      <li><a href="https://sanxmultitrades.com/income/bot">BOT Income</a></li>
                      <li><a href="https://sanxmultitrades.com/income/binary">Binary Income</a></li>
                      <li><a href="https://sanxmultitrades.com/income/level">Level Income</a></li>
                      <li><a href="https://sanxmultitrades.com/income/rank">Rank Income</a></li>
                    </ul>
                  </li>
                  <li>
                    <a href="#"><i className="fas fa-users"></i>Team</a>
                    <ul className="sub-menu">
                      <li><a href="https://sanxmultitrades.com/team/direct">Direct</a></li>
                      <li><a href="https://sanxmultitrades.com/team/level">Level</a></li>
                      <li><a href="https://sanxmultitrades.com/team/binary">Binary</a></li>
                      <li><a href="https://sanxmultitrades.com/team/myteam">My Team</a></li>
                    </ul>
                  </li>
                  <li>
                    <a href="#"><i className="fas fa-wallet"></i>Wallet</a>
                    <ul className="sub-menu" >
                      <li><a href="#">Main Wallet</a>
                        <ul className="sub-menu" style={{ marginLeft: '160px' }}>
                          <li><a href={`/deposit/${userid}`}>Deposit</a></li>
                          <li><a href="https://sanxmultitrades.com/wallet/transfer">Transfer</a></li>
                          <li><a href={`/withdrawal/${userid}`}>Withdrawal</a></li>
                          <li><a href="https://sanxmultitrades.com/wallet/transaction-history">Transaction History</a></li>
                        </ul>
                      </li>
                      <li><a href="https://sanxmultitrades.com/wallet/income-wallet">Income Wallet</a></li>
                      <li><a href="https://sanxmultitrades.com/wallet/capital-withdrawal">Capital Withdrawal</a></li>
                    </ul>
                  </li>

                  <li><a href="#"><i className="fas fa-toolbox"></i>Business Tool</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="https://sanxmultitrades.com/trading">
                      <i className="fas fa-headset" style={{ marginRight: 5 }} />
                      Live Trading
                    </a>
                  </li>
                  <li><a href="https://sanxmultitrades.com/dashboard/support"><i className="fas fa-headset"></i>Support</a></li>

                </ul>
              </div>
              <div className="header-meta">
                <div className="header-btn-2 d-none d-xl-block">
                  <a className="btn" href="https://sanxmultitrades.com/logout">Logout</a>
                </div>
                <div className="header-toggle d-lg-none">
                  <button data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample">
                    <span></span>
                    <span></span>
                    <span></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Offcanvas Start*/}
        <div className="offcanvas offcanvas-start" id="offcanvasExample">
          <div className="offcanvas-header">
            {/* Offcanvas Logo Start */}
            <div className="offcanvas-logo">
              <a href="#">
                <img src="/assets/img/logo.png" alt="" />
              </a>
            </div>
            {/* Offcanvas Logo End */}
            <button type="button" className="close-btn" data-bs-dismiss="offcanvas">
              <i className="fas fa-times" />
            </button>
          </div>
          {/* Offcanvas Body Start */}
          <div className="offcanvas-body">
            <div className="offcanvas-menu">
              <nav className="navbar navbar-expand-lg navbar-light">
                <div className="container-fluid">
                  <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                    <li className="nav-item">
                      <a className="nav-link" href="https://sanxmultitrades.com/dashboard">
                        <i className="fas fa-home" style={{ marginRight: 5 }} />
                        Dashboard
                      </a>
                    </li>
                    <li className="nav-item dropdown">
                      <a
                        className="nav-link"
                        href="#"
                        id="navbarDropdown"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i className="fas fa-user" style={{ marginRight: 5, fontSize: 10 }} />
                        Profile
                        <div className="off-dropdown">
                          <i
                            className="fas fa-caret-down"
                            style={{ marginLeft: 7, fontSize: 25, marginTop: 2 }}
                          />
                        </div>
                      </a>
                      <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li>
                          <a className="dropdown-item" href="https://sanxmultitrades.com/profile/user-details">
                            User Details
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="https://sanxmultitrades.com/profile/update-wallet">
                            Wallet Address
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="https://sanxmultitrades.com/profile/change-password">
                            Change Password
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="https://sanxmultitrades.com/profile/refferal-link">
                            Refferal Link
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li className="nav-item dropdown">
                      <a
                        className="nav-link"
                        href="#"
                        id="navbarDropdown"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i
                          className="fas fa-shopping-cart"
                          style={{ marginRight: 5 }}
                        />
                        Subscription
                        <div className="off-dropdown">
                          <i
                            className="fas fa-caret-down"
                            style={{ marginLeft: 8, fontSize: 25, marginTop: 2 }}
                          />
                        </div>
                      </a>
                      <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                        {/* <li>
<a className="dropdown-item" href={`/botfee/${userid}`}>
BOT Fee
</a>
</li>
<li>
<a className="dropdown-item" href={`/package/${userid}`}>
Package
</a>
</li> */}
                        <li><a href="https://sanxmultitrades.com/subscription/bot-fee">BOT Fee</a></li>
                        <li><a href="https://sanxmultitrades.com/subscription/package">Package</a></li>
                      </ul>
                    </li>
                    <li className="nav-item dropdown">
                      <a className="nav-link"
                        href="#"
                        id="navbarDropdown"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i
                          className="fas fa-dollar-sign"
                          style={{ marginRight: 5 }}
                        />
                        Income
                        <div className="off-dropdown">
                          <i className="fas fa-caret-down" style={{ marginLeft: 8, fontSize: 25, marginTop: 2 }} />
                        </div>
                      </a>
                      <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li>
                          <a className="dropdown-item" href="https://sanxmultitrades.com/income/roi">ROI</a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="https://sanxmultitrades.com/income/bot">BOT Income</a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="https://sanxmultitrades.com/income/binary">Binary Income</a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="https://sanxmultitrades.com/income/level">Level Income</a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="https://sanxmultitrades.com/income/rank">Rank Income</a>
                        </li>
                      </ul>
                    </li>
                    <li className="nav-item dropdown">
                      <a className="nav-link" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <i className="fas fa-users" style={{ marginRight: 5 }} />Team
                        <div className="off-dropdown">
                          <i className="fas fa-caret-down" style={{ marginLeft: 9, fontSize: 25, marginTop: 2 }} />
                        </div>
                      </a>
                      <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li>
                          <a className="dropdown-item" href="https://sanxmultitrades.com/team/direct">  Direct</a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="https://sanxmultitrades.com/team/level"> Level</a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="https://sanxmultitrades.com/team/binary"> Binary</a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="https://sanxmultitrades.com/team/myteam">
                            My Team
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li className="nav-item dropdown">
                      <a className="nav-link" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <i className="fas fa-wallet" style={{ marginRight: 5 }} />Wallet
                        <div className="off-dropdown">
                          <i className="fas fa-caret-down" style={{ marginLeft: 9, fontSize: 25, marginTop: 2 }} />
                        </div>
                      </a>
                      <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li>
                          <a className="dropdown-item" href="#"> Main Wallet</a>
                          <ul className="sub-menu" style={{ marginLeft: 34, listStyle: "disc", color: "white" }}>
                            <li>
                              <a href={`/deposit/${userid}`} style={{ color: "white" }}>  Deposit</a>
                            </li>
                            <li>
                              <a href="https://sanxmultitrades.com/wallet/transfer" style={{ color: "white" }}> Transfer</a>
                            </li>
                            <li>
                              <a href={`/withdrawal/${userid}`} style={{ color: "white" }}> Withdrawal</a>
                            </li>
                            <li>
                              <a href="https://sanxmultitrades.com/wallet/transaction-history" style={{ color: "white" }}> Transaction History</a>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <a className="dropdown-item" href="https://sanxmultitrades.com/wallet/income-wallet"> Income Wallet</a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="https://sanxmultitrades.com/wallet/capital-withdrawal">
                            Capital Withdrawal
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#">
                        <i className="fas fa-toolbox" style={{ marginRight: 5 }} />
                        Business Tool
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="https://sanxmultitrades.com/trading">
                        <i className="fas fa-headset" style={{ marginRight: 5 }} />
                        Live Trading
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="https://sanxmultitrades.com/dashboard/support">
                        <i className="fas fa-headset" style={{ marginRight: 5 }} />
                        Support
                      </a>
                    </li>
                  </ul>
                </div>
              </nav>
              <div className="header-btn-2 d-xl-none" style={{ marginTop: 30, marginBottom: 30 }}>
                <a className="btn" href="https://sanxmultitrades.com/logout" style={{ width: "100%" }}> Logout</a>
              </div>
            </div>
          </div>
          {/* Offcanvas Body End */}
        </div>
        {/* Offcanvas End */}


      </div>
      {/*withdrawal section start*/}
      <div className="dashboard-section section about-section-6 section-padding-03" style={{ marginTop: 25 }}>
        <div className="container">
          <h2 className="text-center" style={{ marginBottom: 20 }}> Withdrwal</h2>
          <center style={{ marginBottom: 20 }}>
            <p style={{ color: "red", fontSize: 18 }}>Total Withdrwal : {totalwithdrawal}$</p>
            <p style={{ color: "green", fontSize: 18 }}>Available Balance: {totalbalance}$</p>
            <p style={{ color: "#005de0", fontSize: 18 }}>
              Withdrawal Charge: 3$ (less than 100$) and 5% (greater than 100$)
            </p>
          </center>
          <div className="row">
            <div className="col-12">
              <form action="#">


                {addresscheck ?
                  <div className="card-box">
                    <div className="card-body">
                      <div className="row">
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1">
                            <p className="select-class mt-3">To[Address]</p>
                          </label>
                          <input className="form-control" value={addresscheck} placeholder="Enter Your Address" type="text" readOnly />

                          <span style={{ color: 'red' }}>{erroraddress}</span>
                        </div>
                        <div className="col-12">
                          <div className="form-group">
                            <label>
                              <p className="select-class mt-3">
                                Enter Your Withdrawal Amount
                              </p>
                            </label>
                            <input className="form-control" onChange={withdrawalamount} placeholder="Enter Your Withdrawal Amount" type="text" />
                            <span style={{ color: 'red' }}>{erroramount}</span>
                          </div>

                        </div>
                        <div className="col-12">
                          <div className="form-group">
                            <label>
                              <p className="select-class mt-3">Receive Amount</p>
                            </label>
                            <input className="form-control" placeholder="Receive Amount" type="text" value={receiveamount} readOnly />
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-group">
                            <label>
                              <p className="select-class mt-3">Transcation Charges</p>
                            </label>
                            <input className="form-control" placeholder="Transcation Charges" type="text" value={transactioncharge} readOnly />
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-group">
                            <label>
                              <p className="select-class mt-3">Final Amount</p>
                            </label>
                            <input className="form-control" placeholder="Final Amount" type="text" value={finalamount} readOnly />

                          </div>

                          {otpbox == 1 &&
                            <div>
                              <div className="col-12">
                                <input type="text" onChange={e => setOtp(e.target.value)} className="form-control border-0 mt-2" placeholder="Enter Email OTP" style={{ height: '55px' }} />
                                <span style={{ color: 'green' }}>OTP has been sent to your email address</span>
                              </div>
                              <div className="col-12">
                                <input type="text" onChange={e => setMobileotp(e.target.value)} className="form-control border-0 mt-2" placeholder="Enter Mobile OTP" style={{ height: '55px' }} />
                                <span style={{ color: 'green' }}>OTP has been sent to your Mobile No</span>
                              </div>
                            </div>
                          }

                          <center>
                            {otpbox == 0 && day == 3 && withdrawallock == 1 &&
                              <div className="col-md-12">
                                {loading === 'off' ?
                                  <p>
                                    {/* <button className="btn btn-primary mt-3" type="button" onClick={nextbuttonclick} disabled={new Date(new Date().toLocaleString("en-US",{timeZone:"Asia/Kolkata"})).getHours() < 9} >
                                      Next
                                    </button> */}
                                  </p>
                                  :
                                  <button className="btn btn-primary" type="button">Processing....</button>
                                }

                                {errormsg != null &&
                                  <div className='alert alert-danger mt-2'>{errormsg}</div>
                                }
                                {successmsg != null &&
                                  <div className='alert alert-success mt-2'>{successmsg}</div>
                                }
                              </div>
                            }
                            <span style={{ color: 'red' }}>{errormassege}</span>
                            {otpbox == 1 &&
                              <div className="col-md-12">
                                {loading === 'off' ?
                                  <p>
                                    <button className="btn btn-primary mt-3" type="button" onClick={submitform} disabled={locked}>Submit</button>
                                  </p>
                                  :
                                  <button className="btn btn-primary" type="button">Processing....</button>
                                }
                                {errormsg != null &&
                                  <div className='alert alert-danger mt-2'>{errormsg}</div>
                                }
                                {successmsg != null &&
                                  <div className='alert alert-success mt-2'>{successmsg}</div>
                                }
                              </div>
                            }
                          </center>

                        </div>
                      </div>
                    </div>
                  </div>
                  :
                  <div className="card-box">
                    <div className="card-body">
                      <label style={{ color: "red", textAlign: "center" }}>Please update your Wallet Address</label>
                    </div>
                  </div>
                }


              </form>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <p className="text-center" style={{ marginTop: 80, fontSize: 25, marginBottom: 20 }}>
                <strong>Withdrawal History</strong>
              </p>
              <div className="card-table">
                <div className="card-body">
                  <div className="table-responsive text-nowrap" style={{ marginTop: 25 }}>
                    <table className="table">
                      <thead className="table-head">
                        <tr>
                          <th scope="col">Sl No.</th>
                          <th scope="col">Date</th>
                          <th scope="col">Amount</th>
                          <th scope="col">Address</th>
                          <th scope="col">Transaction No.</th>
                          <th scope="col">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {userwithdrawal.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                              {moment(item.created_at).format(
                                "YYYY/MM/DD kk:mm:ss"
                              )}
                            </td>
                            <td>${item.amount}</td>
                            <td>{item.address}</td>
                            <td>{item.trans_no}</td>
                            <td>
                              {item.status === 1 ?
                              <span className="text-primary">In Review</span>
                              :
                              item.status === 2 ?
                              <span className="text-success">Success</span>
                              :
                              <span className="text-danger">Failed</span>
                              }
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*withdrawal section end*/}



      {/* Footer Section Start */}
      <div className="section footer-section" style={{ backgroundImage: "url(assets/img/banner/testi-bg.jpg)" }}>
        <div className="container">
          {/* Footer Widget Wrap Start */}
          <div className="footer-widget-wrap footer-widget-wrap-2">
            <div className="row">
              <div className="col-lg-4 col-sm-6">
                {/* Footer Widget Start */}
                <div className="footer-widget-about">
                  <a className="footer-logo" href="index.html">
                    <img src="/assets/img/logo.png" alt="Logo" style={{ width: "100%", height: 50 }} />
                  </a>
                  <div className="widget-info">
                    <p style={{ color: "white", textAlign: "justify" }}>
                      Once you’ve entered into our ecosystem, you can mange every
                      thing. Anyone with a smartphone and an internet.
                    </p>
                  </div>
                </div>
                {/* Footer Widget End */}
              </div>
              <div className="col-lg-4 col-sm-6">
                {/* Footer Widget Start */}

                {/* Footer Widget End */}
              </div>
              <div className="col-lg-4 col-sm-6">
                {/* Footer Widget Start */}

                {/* Footer Widget End */}
              </div>
              <div className="col-lg-12 col-md-12">
                {/* Footer Copyright Text Start */}
                <center>

                  <div className="copyright-text">
                    <p>© 2023 Sanx. All Rights Reserved by Sanx Million Trade</p>
                  </div>
                </center>
                {/* Footer Copyright Text End */}
              </div>
            </div>
          </div>
          {/* Footer Widget Wrap End */}
        </div>
        {/* Footer Copyright Start */}
        <div className="footer-copyright-area">
          <div className="container">
            <div className="footer-copyright-wrap">
              <div className="row align-items-center">
                <div className="col-lg-6 col-md-6">
                  {/* Footer Copyright Social Start */}
                  <div className="copyright-social">
                    <ul className="social">
                      <li>
                        <a href="#">
                          <i className="fab fa-facebook-f" />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fab fa-twitter" />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fab fa-linkedin-in" />
                        </a>
                      </li>
                    </ul>
                  </div>
                  {/* Footer Copyright Social End */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Footer Copyright End */}
      </div>
      {/* Footer Section End */}
    </div>
  )
}
